import httpClient from "./httpClient";

export function listPlatformInstitutes() {
  return httpClient.get("/platform/institutes").then((res) => res.data.data);
}

export function createPlatformInstitute(payload) {
  return httpClient.post("/platform/institutes", payload).then((res) => res.data.data);
}

export function activatePlatformInstitute(instituteId) {
  return httpClient.put(`/platform/institutes/${instituteId}/activate`).then((res) => res.data.data);
}

export function deactivatePlatformInstitute(instituteId) {
  return httpClient.put(`/platform/institutes/${instituteId}/deactivate`).then((res) => res.data.data);
}
